/*=========================================================================================
  File Name: state.js
  Namespace: videos
  Description: Vuex Store - Video state
==========================================================================================*/
import { CUSTOM_CONTENT_AUDIENCE_TYPES } from '@/constants/customContent'

export const buildVideoState = () => {
  return {
    id: null,
    name: '',
    source: null,
    duration_in_seconds: null,
    jwplayer_id: null,
    slug: null,
    created: null,
    modified: null,
    status: null,
    metadata: null,
    instructor_id: null,
    files: [],
    type: 'lesson',
    audience_type: CUSTOM_CONTENT_AUDIENCE_TYPES.PUBLIC,
  }
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  currentVideo: buildVideoState(),
  videoList: null,
  count: 0,
  next: null,
  previous: null,
  results: [],
  currentVideoFiles: []
}

export default state
